module.exports = __webpack_public_path__ + "img/18@2x.15bb0b4f.png";